import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Snackbar, Button } from "@mui/material";
import Alert from "@mui/material/Alert";
import OrderDetail from "../components/OrderDetails";
import OrdersTable from "../components/OrdersTable";
import SyncProblemIcon from "@mui/icons-material/SyncProblem";
import { useStore } from "../authContext/StoreContext";
import { useSnackbar } from "notistack";
import api from "../hooks/apiClient";
const Orders = () => {
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const { selectedStore, isStoreSelected } = useStore();
  const activeButton = isStoreSelected && selectedStore.id;
  const [order, setOrder] = useState();

  const [open, setOpen] = useState(false);
  const ToggleOpen = () => {
    setOpen(!open);
  };

  const ViewOrder = async (id) => {
    try {
      const response = await api.get(`orders/finddetails/${id}`, {});
      const order = response.data;

      setOrder(order.line_items);

      ToggleOpen();
    } catch (error) {
      console.error(error);
    }
  };
  const ViewOrderDetails = async (id) => {
    navigate(`/orders/${id}`);
  };

  if (!isStoreSelected) {
    return (
      <div>
        <SyncProblemIcon />
        {!isStoreSelected && <p>No Store Selected</p>}
      </div>
    );
  }
  return (
    <div>
      <OrderDetail open={open} ToggleOpen={ToggleOpen} data={order} />

      <>
        <OrdersTable
          ViewOrder={ViewOrder}
          ViewOrderDetails={ViewOrderDetails}
          store_id={activeButton}
        />
      </>
    </div>
  );
};

export default Orders;
